document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth < 990) return; // Skip on mobile

  const header = document.querySelector('header'); // Adjust selector if needed
  const thumbs = document.querySelectorAll('[data-scroll-thumb]');
  const images = document.querySelectorAll('[data-scroll-image]');
  const stickyThumbs = document.querySelectorAll('[data-sticky-thumbs]');

  function getHeaderHeight() {
    return header?.offsetHeight || 0;
  }

  // --------- Scroll direction logic for sticky positioning ---------
  let lastScrollY = window.scrollY;

  function updateStickyThumbsPosition() {
    const currentScrollY = window.scrollY;
    const scrollingUp = currentScrollY < lastScrollY;
    const newTop = scrollingUp ? getHeaderHeight() : 0;

    stickyThumbs.forEach(el => {
      el.style.top = `${newTop}px`;
    });

    lastScrollY = currentScrollY;
  }

  window.addEventListener('scroll', updateStickyThumbsPosition);
  window.addEventListener('resize', updateStickyThumbsPosition); // In case header height changes

  // --------- Get scroll container ---------
  const scrollContainer = document.querySelector('.product-gallery-scroll-hidden');

  // --------- Scroll to image on thumb click ---------
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', e => {
      e.preventDefault();
      const targetId = thumb.dataset.target;
      const target = document.getElementById(targetId);

      if (target && scrollContainer) {
        // Scroll within the scroll container, not the page
        const containerRect = scrollContainer.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();
        const scrollOffset = targetRect.top - containerRect.top;
        
        scrollContainer.scrollTo({
          top: scrollContainer.scrollTop + scrollOffset,
          behavior: 'smooth'
        });
      }
    });
  });

  // --------- Highlight active thumb on scroll ---------
  
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const id = entry.target.getAttribute('id');
          thumbs.forEach(t => t.classList.remove('active'));
          const matchingThumb = document.querySelector(`[data-scroll-thumb][data-target="${id}"]`);
          if (matchingThumb) matchingThumb.classList.add('active');
        }
      });
    },
    {
      root: scrollContainer,
      rootMargin: '0px 0px -70% 0px',
      threshold: 0.1,
    }
  );

  images.forEach(img => observer.observe(img));
});